import {
  EShortcutsDate,
  IDateRange,
  IShortcutHandler
} from "@/core/composables/F360DateShortcuts/types";
import { IMapNamesShortcut } from "@/composables/shared/types";
import type { IF360DateUtils } from "@/core/plugins/date/F360DateUtils";
import { F360UnitDate, type IF360Date } from "@/core/plugins/date/F360Date";
import { EShortcutsDateContabil } from "./types";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";

@injectable()
export default class ContabilShortcutHandler
  implements IShortcutHandler<EShortcutsDate<EShortcutsDateContabil>>
{
  shortcuts: Map<EShortcutsDate<EShortcutsDateContabil>, IDateRange>;
  shortcutNames: IMapNamesShortcut<EShortcutsDateContabil>;

  private dateUtils!: IF360DateUtils;

  private date!: IF360Date;

  constructor(
    @inject(DITypes.DATE) date: IF360Date,
    @inject(DITypes.DATE_UTILS) dateUtils: IF360DateUtils
  ) {
    this.date = date;
    this.dateUtils = dateUtils;

    this.shortcuts = new Map<
      EShortcutsDate<EShortcutsDateContabil>,
      IDateRange
    >([
      [
        EShortcutsDateContabil.ultimoAno,
        this.dateUtils.formatToDateRange(
          this.date.subtract(this.date.now(), 1, F360UnitDate.Year)
        )
      ],
      [
        EShortcutsDateContabil.ultimoSemestre,
        this.dateUtils.formatToDateRange(
          this.date.subtract(this.date.now(), 6, F360UnitDate.Month)
        )
      ],
      [
        EShortcutsDateContabil.ultimosTresMeses,
        this.dateUtils.formatToDateRange(
          this.date.subtract(this.date.now(), 3, F360UnitDate.Month)
        )
      ],
      [
        EShortcutsDateContabil.ultimaAtualizacao,
        this.dateUtils.formatToDateRange(
          this.date.subtract(this.date.now(), 0, F360UnitDate.Month)
        )
      ]
    ]);

    this.shortcutNames = [
      [EShortcutsDateContabil.ultimoAno, "Último ano"],
      [EShortcutsDateContabil.ultimoSemestre, "Último semestre"],
      [EShortcutsDateContabil.ultimosTresMeses, "Últimos três meses"],
      [EShortcutsDateContabil.ultimaAtualizacao, "Última atualização"]
    ];
  }

  handle(
    payload: EShortcutsDate<EShortcutsDateContabil>
  ): IDateRange | undefined {
    const rangeDate = this.shortcuts.get(payload) || undefined;

    return rangeDate;
  }
}
